// extracted by mini-css-extract-plugin
export default {"cover_img":"GenreHomeHalfBanner_cover_img__SgXVV","swiper-slide":"GenreHomeHalfBanner_swiper-slide__G+Vqh"};